var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcn1Process(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86.267,
    height: 86.936,
    viewBox: "0 0 86.267 86.936",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn1-process",
    transform: "translate(-859.35 -1753.645)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2427",
    "data-name": "Groupe 2427",
    transform: "translate(859.35 1753.645)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_251",
    "data-name": "Rectangle 251",
    width: 86.267,
    height: 86.936,
    rx: 20,
    fill: "#defdff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2630",
    "data-name": "Groupe 2630",
    transform: "translate(817.496 1712.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2959",
    "data-name": "Trac\\xE9 2959",
    d: "M58,231.942a1.956,1.956,0,0,1,2.022-1.146q24.367.028,48.734.013c1.414,0,1.952.539,1.952,1.957q0,9.39,0,18.78c0,1.346-.559,1.907-1.9,1.907q-24.367,0-48.734.014A1.99,1.99,0,0,1,58,252.321Zm33.407,11.651.287-.149a4.207,4.207,0,0,0,2.4-4.327,4.162,4.162,0,0,0-3.64-3.591,25.785,25.785,0,0,0-3.335-.08,1.534,1.534,0,0,0-1.637,1.644c-.007,1.234,0,2.468,0,3.7,0,2.142-.005,4.285,0,6.427a1.538,1.538,0,0,0,1.526,1.6,1.557,1.557,0,0,0,1.557-1.579c.01-.325,0-.651,0-.977,0-.361,0-.722,0-1.215,1,1.138,1.9,2.153,2.788,3.17a1.544,1.544,0,1,0,2.36-1.989C92.982,245.352,92.208,244.5,91.407,243.593ZM75.6,240.38c0-1.151.009-2.246,0-3.341a1.541,1.541,0,1,0-3.081-.01q-.013,5.093,0,10.185a1.543,1.543,0,1,0,3.083-.023c.009-1.063,0-2.126,0-3.189,0-.163.014-.326.021-.483h4.005v.531c0,1.012,0,2.023,0,3.035a1.584,1.584,0,0,0,1.562,1.735,1.551,1.551,0,0,0,1.524-1.707c0-1.389,0-2.778,0-4.167,0-1.972.007-3.944,0-5.916a1.525,1.525,0,0,0-1.486-1.587,1.566,1.566,0,0,0-1.595,1.544c-.013.257,0,.514,0,.772,0,.868,0,1.736,0,2.622Z",
    transform: "translate(0 -148.412)",
    fill: "#00bcc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2960",
    "data-name": "Trac\\xE9 2960",
    d: "M93.473,421.509c-1.544-.684-1.058-2.048-1.131-3.267h6.1c.426,1.522.087,2.579-1.052,3.267Z",
    transform: "translate(-29.605 -310.085)",
    fill: "#00bcc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2961",
    "data-name": "Trac\\xE9 2961",
    d: "M363.072,421.509c-1.26-.712-1.2-1.107-1.085-3.267h6.049c.426,1.522.087,2.579-1.052,3.267Z",
    transform: "translate(-262.143 -310.085)",
    fill: "#00bcc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2962",
    "data-name": "Trac\\xE9 2962",
    d: "M100.381,142.606a8.844,8.844,0,0,0,13.029.019c2.922,1.493,4.658,5.147,4.257,9H96.144A8.929,8.929,0,0,1,100.381,142.606Z",
    transform: "translate(-32.837 -72.347)",
    fill: "#00bcc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2963",
    "data-name": "Trac\\xE9 2963",
    d: "M287.139,143.83c.46-1.156.912-2.3,1.368-3.438q1.115-2.79,2.234-5.579a1.628,1.628,0,0,1,1.834-1.241q5.378,0,10.756,0a1.573,1.573,0,0,1,1.611,2.361q-1.5,3.771-3.009,7.538c-.092.231-.172.4-.494.4q-7.051-.019-14.1-.011A1.58,1.58,0,0,1,287.139,143.83Z",
    transform: "translate(-197.634 -64.555)",
    fill: "#00bcc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2964",
    "data-name": "Trac\\xE9 2964",
    d: "M144.956,64.377a5.66,5.66,0,1,1-5.668-5.651A5.67,5.67,0,0,1,144.956,64.377Z",
    transform: "translate(-65.236 0)",
    fill: "#00bcc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2965",
    "data-name": "Trac\\xE9 2965",
    d: "M280.542,289.3v-2.234a13.028,13.028,0,0,1,1.375.01,1.173,1.173,0,0,1,1.069,1.125,1.192,1.192,0,0,1-1.108,1.092C281.455,289.333,281.026,289.3,280.542,289.3Z",
    transform: "translate(-191.944 -196.932)",
    fill: "#00bcc9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcn1Process);
export default __webpack_public_path__ + "static/media/icn1-process.c10b7ad50a141b9a65bc49345ef28da8.svg";
export { ForwardRef as ReactComponent };